import * as React from "react";
const SvgPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8,5.14V19.14L19,12.14L8,5.14Z" }));
export default SvgPlay;
